<template>
    <client-page class="app--main">
        <!-- S: sub-visual -->
        <section class="sub-visual">
            <v-container>
                <div class="tit-wrap mb-24 mb-md-50 mb-lg-0">
                    <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                    <h2 class="tit tit--xl">
                        Business
                    </h2>
                </div>
            </v-container>
            <v-img class="sub-visual__img" src="/images/sub/company/sub-visual-company.jpg"></v-img>
            <sub-tab page="회사소개" :tabActive="1"></sub-tab>
        </section>
        <!-- E: sub-visual -->

        <!-- S: greeting -->
        <section class="sub-section sub-section--greeting">
            <v-container>
                <v-row no-gutters class="justify-space-between">
                    <v-col cols="12" lg="5">
                        <div class="tit-wrap">
                            <h3 class="tit tit--lg font-pretendard line-height-135" data-aos="fade-right">
                                안녕하세요.<br />
                                (주)모두에프엔티 홈페이지에<br />
                                방문해 주셔서 감사합니다.
                            </h3>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6" data-aos="fade-left">
                        <div class="page-text grey--text">
                            <p>
                                MODOO F&T는 모두를 위한 Food & Total 이라는 뜻을 가지고 있으며 26년간의 노하우로 그동안 <br class="d-none d-xl-block" />
                                다진 탄탄한 정보망과 네트워크를 통해 각종 업체들에게 2,000가지의 다양한 카테고리의 제품을 <br class="d-none d-xl-block" />
                                공급하여 맞춤화 서비스를 제공해 드립니다.
                            </p>
                            <p>
                                모두에프엔티는 최상의 식재료 품질과 체계적 유통 시스템으로 고객 만족을 실현하고 있습니다. <br class="d-none d-xl-block" />
                                One stop shopping 으로 한번에 식자재 세팅을 위해 경쟁력 있는 가격, 그리고 신뢰를 바탕으로 한 <br class="d-none d-xl-block" />
                                기업간의 협업으로 양질의 상품을 전달합니다.
                            </p>
                            <p>
                                <span class="primary--text">"모두가 잘 먹고 잘 살 수 있다면"</span><br />
                                모두에프엔티가 꿈꾸는 세상은 우리 모두가 잘 먹고 잘 사는 세상입니다.
                            </p>
                            <p>
                                단순히 식재료를 전달하는 것 이상으로, 고객에겐 건강한 라이프스타일의 가치를 전달하고 <br class="d-none d-xl-block" />
                                파트너사와는 함께 상생하는 기업으로서 성장하고자 합니다.
                            </p>
                            <p>
                                모두와 함께하는 모두에게 건강한 행복을 선물하겠습니다.<br />
                                감사합니다.
                            </p>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubTab from "@/components/client/sub/sub-tab.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        SubTab,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 120,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        // pc
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
